import { IPolicyHoldersInput } from '@nibtravel/shared/util/models';

/* eslint-disable @typescript-eslint/no-namespace */
export namespace PlansAction {
  /**
   * Action to get plan data from api based on planIds in Prices obtained from Quote
   */
  export class LoadPlansData {
    public static readonly type = '[Plans] Load plans and benefits';

    constructor(public planIds: number[], public brand: string) {}
  }

  export class CalculatePlanBenefitsSummary {
    public static readonly type = '[Plans] Calculate plan benefits summary';
  }

  /**
   * Action to fetch plan options Summary
   */
  export class LoadOptionsSummary {
    public static readonly type = '[Plans] Load plan options summary';

    /**
     *
     * @param planId number
     * @param brand string
     */
    constructor(public planId: number, public brand: string) {}
  }

  export class CalculateImplicitCancellationValue {
    public static readonly type =
      '[Plans] Calculate implicit cancellation value';

    constructor(
      public planId: number,
      public policyHolders: IPolicyHoldersInput[]
    ) {}
  }
}
